import React from "react";
import Separator from "../../../../../global components/Icons/Separator";
import { Link, Outlet, useLocation } from "react-router-dom";
import BreadCrumb from "../../../../../global components/BreadCrumbs/BreadCrumbs";
import s from "./APIManagementWrapper.module.scss";
import clsx from "clsx";
import { ArrowRightArrowLeft } from "../../../../../global components/Icons/ArrowRightArrowLeft";
type NavigationStateType = {
  fullName: string;
};
function APIManagementWrapper() {
  const location = useLocation();
  const { fullName = "" } = (location.state as NavigationStateType) || {};
  const pathName = location.pathname;
  const items = [
    {
      title: (
        <Link to="/dashboard/api-management">
          <ArrowRightArrowLeft className={s.icon} /> API management
        </Link>
      ),
    },
  ];

  if (pathName.includes("users")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("users") && s.active)}
          to="/dashboard/api-management/requests/users"
        >
          User
        </Link>
      ), // Added title text
    });
  } else if (pathName.includes("ranking")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("requests/ranking") && s.active)}
          to="/dashboard/api-management/requests/ranking"
        >
          Key Activity Ranking
        </Link>
      ), // Added title text
    });
  } else if (pathName.includes("requests")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          className={clsx(pathName.includes("requests") && s.active)}
          to="/dashboard/api-management/requests"
        >
          API Requests
        </Link>
      ), // Added title text
    });
  }
  if (pathName.includes("view-details")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          aria-disabled
          className={clsx(pathName.includes("view-details") && s.active)}
          to="/dashboard/api-management/requests/user/view-details"
        >
          {fullName}
        </Link>
      ), // Added title text
    });
  }
  if (pathName.includes("activity-details")) {
    items.push({
      title: (
        <Link
          onClick={(e) => e.preventDefault()}
          aria-disabled
          className={clsx(pathName.includes("activity-details") && s.active)}
          to="/dashboard/api-management/requests/ranking/activity-details"
        >
          Activity details{" "}
        </Link>
      ), // Added title text
    });
  }
  return (
    <div className={s.wrapper}>
      <div className={s.breadCrumb}>
        <BreadCrumb
          items={items}
          separator={<Separator height={11} width={6.67} fill="#9CA3AF" />}
        />
      </div>
      <Outlet />
    </div>
  );
}

export default APIManagementWrapper;
